import { constants } from "../constants/redux-constants";

const initialState = {};

const tempDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.SET_TEMP_DATA:
      return {
        ...action.payload,
      };
    case constants.APPEND_TEMP_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case constants.SET_TEMP_DATA_RESET:
      return initialState;
    default:
      return state;
  }
};

export default tempDataReducer;
